const CheckoutProductMixTypes = {
  NO_DIGITAL: 'NO_DIGITAL',
  MIX_OF_DIGITAL: 'MIX_OF_DIGITAL',
  ONLY_DIGITAL: 'ONLY_DIGITAL'
}

export default CheckoutProductMixTypes
